import { graphql } from "@opensea/graphql"

export const ViewWalletPortfolioValueFragment = graphql(`
  fragment ViewWalletPortfolioValue on Volume {
    usd
    native {
      unit
      symbol
    }
  }
`)
